var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time"},[_c('div',{staticClass:"notime"},[_vm._v(_vm._s(_vm.nowTime))]),_c('div',{staticClass:"line"}),_c('div',[_c('span',[_vm._v(_vm._s(_vm.nowday))]),_c('p',{staticStyle:{"margin-top":"10px"}},[_vm._v(_vm._s(_vm.nowWeek))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }